import { combineReducers } from "redux";

import callLists from './reducers/call_lists';
import companies from './reducers/companies';
import duplicates from './reducers/duplicates';
import people from './reducers/people';
import query from './reducers/query';
import session from './reducers/session';
import search from './reducers/search';
import selectList from './reducers/select_list';
import ui from './reducers/ui';

const nullReducer = state => ({ ...state });

export default combineReducers({
  callLists,
  companies,
  duplicates,
  mappings: nullReducer,
  paths: nullReducer,
  people,
  query,
  search,
  selectList,
  session,
  static: nullReducer,
  ui
});
